import React from 'react';
import TPBDownloads from '../components/TPBDownloads';
import InteractiveGlobe from '../components/InteractiveGlobe';
import { Link, useParams } from 'react-router-dom';
import { useLangTranslation } from '../utils/translation';

export default function Home() {
  const { lang = 'en' } = useParams();
  const t = useLangTranslation('games');
  return <div className="edge-home">
    <section className="edge-home-hero">
      <div className="edge-intro-copy">
        <p className="edge-eyebrow">EDGE · INDEPENDENT GAME STUDIO</p>
        <h1>{t('headline')}</h1><p className="edge-lead">{t('intro')}</p>
        <div className="edge-actions"><Link className="edge-button" to={`/${lang}/games`}>{t('title')} <span>↗</span></Link><Link className="edge-text-link" to={`/${lang}/about`}>{t('about')} →</Link></div>
      </div>
      <div className="home-globe-stage"><InteractiveGlobe /></div>
      <div className="hero-signature"><img src="/assets/logo-white.svg" alt="EDGE"/><span>FROM KOREA. FOR THE WORLD.</span></div>
    </section>
    <section className="edge-featured">
      <div><p className="edge-eyebrow">01 / CURRENTLY IN DEVELOPMENT</p><h2>TPB</h2><p className="tpb-full-name">Tactical Position Battle</p><p>{t('games.tpb.description')}</p><Link className="edge-text-link" to={`/${lang}/tpb`}>{t('explore')} ↗</Link><TPBDownloads /></div>
      <Link className="edge-showcase" to={`/${lang}/tpb`} aria-label="TPB"><img src="/assets/tpb/tpb-battle.webp" alt="TPB gameplay" loading="lazy"/><div className="edge-showcase-caption"><span>TPB / MOBILE STRATEGY</span><span>{t('status')} ↗</span></div></Link>
    </section>
    <section className="edge-next"><p className="edge-eyebrow">CASUAL / MIDCORE / WHAT’S NEXT</p><h2>{t('futureTitle')}</h2><p>{t('futureDescription')}</p></section>
    <section className="edge-contact"><h2>{t('contactTitle')}</h2><a href="mailto:siwon.oh@play-edge.com">{t('contact')} ↗</a></section>
  </div>;
}
